module.exports = __webpack_public_path__ + "img/logo-invision.43586d43.svg";